function applyBadges() {

    document.querySelectorAll('product-card').forEach(card => {

        /* ==========================================
           GALERIA
        ========================================== */

        const gallery =
            card.querySelector('[data-badges-ready]') ||
            card.querySelector('.card-gallery') ||
            card.querySelector('.custom-product-card-media');

        if (!gallery)
            return;

        /* ==========================================
           QUICK VARIANT
        ========================================== */

        const quickVariant =
            card.querySelector('.quick-variant') ||
            card.querySelector('.quick-variant-fallback');

        if (!quickVariant) {

            if (card.dataset.badgesWaiting)
                return;

            card.dataset.badgesWaiting = 'true';

            setTimeout(() => {

                delete card.dataset.badgesWaiting;

                applyBadges();

            }, 300);

            return;
        }

        /* ==========================================
           EVITA REPROCESSAR
        ========================================== */

        const state =
            `${quickVariant.dataset.collections || ''}|` +
            `${quickVariant.dataset.price || ''}|` +
            `${quickVariant.dataset.comparePrice || ''}|` +
            `${quickVariant.dataset.stock || ''}`;

        if (card.dataset.badgesState === state)
            return;

        card.dataset.badgesState = state;

        /* ==========================================
           DADOS DO PRODUTO
        ========================================== */

        const collections =
            (quickVariant.dataset.collections || '')
                .toLowerCase()
                .split(',')
                .map(item => item.trim())
                .filter(Boolean);

        const price =
            Number(quickVariant.dataset.price) || 0;

        const compare =
            Number(quickVariant.dataset.comparePrice) || 0;

        const stock =
            Number(quickVariant.dataset.stock) || 0;

        const lowStock =
            stock > 0 &&
            stock <= 3;

        const hasDiasOrigem =
            collections.includes('dias-origem');

        /* ==========================================
           BADGES PERSONALIZADAS
        ========================================== */

        const badges = [];

        if (lowStock)
            badges.push('ÚLTIMAS UNIDADES');

        if (collections.includes('best-sellers'))
            badges.push('BEST SELLER');

        if (collections.includes('reposicao'))
            badges.push('REPOSIÇÃO');

        if (collections.includes('novidades'))
            badges.push('NOVIDADE');

        if (compare > price && compare > 0) {

            const percent =
                Math.round(
                    ((compare - price) / compare) * 100
                );

            badges.push(`${percent}% OFF`);
        }

        /* ==========================================
           WRAPPER
        ========================================== */

        let wrapper =
            gallery.querySelector('.product-badges');

        if (!wrapper) {

            wrapper =
                document.createElement('div');

            wrapper.className =
                'product-badges product-badges--top-left';

            gallery.prepend(wrapper);
        }

        /* ==========================================
           VERIFICA ESGOTADO
        ========================================== */

        const hasSoldOut =
            [...wrapper.querySelectorAll('.product-badges__badge')]
                .some(badge =>
                    badge.textContent
                        .trim()
                        .toLowerCase()
                        .includes('esgotado')
                );

        /* ==========================================
           LIMPA NOSSAS BADGES
        ========================================== */

        wrapper
            .querySelectorAll(
                '.na-custom-badge, .na-dias-origem-badge'
            )
            .forEach(el => el.remove());

        /* ==========================================
           REMOVE SALE NATIVO
        ========================================== */

        wrapper
            .querySelectorAll('.product-badges__badge')
            .forEach(el => {

                const text =
                    el.textContent
                        .trim()
                        .toLowerCase();

                if (
                    text.includes('promoção') ||
                    text.includes('promotion') ||
                    text.includes('sale')
                ) {
                    el.remove();
                }

            });

        /* ==========================================
           DIAS ORIGEM
           APARECE JUNTO COM ESGOTADO
        ========================================== */

        if (hasDiasOrigem) {

            const badge =
                document.createElement('div');

            badge.className =
                'product-badges__badge na-dias-origem-badge';

            badge.textContent =
                'DIAS ORIGEM';

            wrapper.appendChild(badge);
        }

        /* ==========================================
           NÃO EXIBE OUTRAS TAGS
           QUANDO ESGOTADO
        ========================================== */

        if (hasSoldOut)
            return;

        /* ==========================================
           BADGES NORMAIS
        ========================================== */

        badges.forEach(text => {

            const badge =
                document.createElement('div');

            badge.className =
                'product-badges__badge product-badges__badge--rectangle na-custom-badge';

            badge.textContent =
                text;

            wrapper.appendChild(badge);

        });

    });

}

window.applyBadges =
    applyBadges;

/* ==========================================
   OBSERVER
========================================== */

let raf = null;

const observer =
    new MutationObserver(mutations => {

        let shouldRun = false;

        for (const mutation of mutations) {

            for (const node of mutation.addedNodes) {

                if (!(node instanceof HTMLElement))
                    continue;

                if (
                    node.classList?.contains('na-custom-badge') ||
                    node.classList?.contains('na-dias-origem-badge')
                )
                    continue;

                if (
                    node.matches?.('product-card') ||
                    node.querySelector?.('product-card')
                ) {
                    shouldRun = true;
                    break;
                }
            }

            if (shouldRun)
                break;
        }

        if (!shouldRun || raf)
            return;

        raf =
            requestAnimationFrame(() => {

                raf = null;

                applyBadges();

            });

    });

observer.observe(document.body, {
    childList: true,
    subtree: true
});

/* ==========================================
   PRIMEIRA EXECUÇÃO
========================================== */

applyBadges();